import React from 'react'
import { DatePickerComponent } from '@syncfusion/ej2-react-calendars'
import './DatePickerStyle.css'

type DatePickerProps = {
  id: string
  format: string
  value: string | Date
  onDateChange: (e: { value: Date }) => void
  className?: string
  placeholder?: string
  openOnFocus?: boolean
  width?: number | string
  showClearButton?: boolean
  allowEdit?: boolean
  showTodayButton?: boolean
  min?: Date
}
function DatePicker({
  id,
  placeholder,
  openOnFocus,
  format,
  className,
  value,
  onDateChange,
  width,
  showClearButton,
  allowEdit,
  showTodayButton,
  min,
}: DatePickerProps): React.ReactElement {
  return (
    <div className="control-pane">
      <div className={`custom-date-picker ${className}`}>
        <DatePickerComponent
          id={id}
          placeholder={placeholder ?? 'Enter date'}
          openOnFocus={openOnFocus}
          format={format}
          value={new Date(value)}
          min={min}
          change={onDateChange}
          strictMode={true}
          width={width}
          showClearButton={showClearButton}
          allowEdit={allowEdit}
          showTodayButton={showTodayButton}
        />
      </div>
    </div>
  )
}

export default DatePicker
